import './NavPictures.scss';

import { NavLink } from 'react-router-dom';


const NavPictures= () => {
  return(
    <section className='navpictures'>
    <h2 className='navpictures_title'> - Categories - </h2>
      <NavLink
        to='/real'
        className='nav_bannPics real'
        > - Réaliste - 
      </NavLink>
     

      <NavLink
        to='/manga'
        className='nav_bannPics manga'
        > - Manga -
       
      </NavLink>

      <NavLink
        to='/jap'
        className='nav_bannPics jap'
        > - Japonais - 
      </NavLink>
      

      <NavLink
        to='/draw'
        className='nav_bannPics draw'
        > - Dessins - 
      </NavLink>

      <NavLink
        to='/autres'
        className='nav_bannPics os'
        > - Autres - 
      </NavLink>
    </section>
  )
}

export default NavPictures;